export const CAMPAIGN_FILTER = {
  ONGOING_CAMPAIGNS: 'ongoingCampaigns',
  ALL_CAMPAIGNS: 'allCampaigns',
  SPECIFIC_YEARS: 'specificYears'
};